import {withParams, req} from 'vuelidate/lib/validators/common';
import decimal from 'vuelidate/lib/validators/decimal';

function optionalBetween(compareTo, predicate, decimalCheck) {
    /* eslint-disable func-names */
    return function (value, $each) {
        // this function executes within the context
        // of the component that defines the `validations` block
        const comparedValue = $each[compareTo];
        if (!req(value) || !req(comparedValue)) {
            return true;
        }
        if (decimalCheck) {
            // first verify the values are decimal
            if (decimal(value) && decimal(comparedValue)) {
                // then call the predicate within the scope
                // of the parent component
                return predicate.call($each, value);
            }
            return false;
        }
        // call the predicate within the scope
        // of the parent component
        return predicate.call($each, value);
    };
}

export default (compareTo, predicate, decimalCheck = true) => withParams({
    type: 'optionalBetween',
    compareTo,
    predicate,
    decimalCheck,
}, optionalBetween(compareTo, predicate, decimalCheck));
